export default {
  products: {
    en: 'Products',
  },
  brands: {
    en: 'Brands',
  },
  notes: {
    en: 'Notes',
  },
  pages: {
    en: 'Pages',
  },
  notFound: {
    all: {
      en: 'No item named “{query}” found',
    },
    products: {
      en: 'No product named “{query}” found',
    },
    brands: {
      en: 'No brand named “{query}” found',
    },
    notes: {
      en: 'No note named “{query}” found',
    },
  },
}
